import { supabase } from '@/lib/supabase';

export type StaffAppointmentEmailKind = 'confirmation' | 'rescheduled' | 'cancelled';

/** Fire-and-forget appointment e-mail (confirmation, change, or cancellation). */
export function sendStaffAppointmentEmail(
  appointmentId: string,
  kind: StaffAppointmentEmailKind,
): void {
  void supabase.functions
    .invoke('send-appointment-email', {
      body: { appointment_id: appointmentId, kind },
    })
    .catch((err: unknown) => {
      console.error('Failed to send appointment email:', err);
    });
}

/** Fire-and-forget patient confirmation for a staff-created appointment. */
export function sendStaffAppointmentConfirmation(appointmentId: string): void {
  sendStaffAppointmentEmail(appointmentId, 'confirmation');
}
